module.exports = __webpack_public_path__ + "static/media/pt-sans.narrow.598f67fb.ttf";